
import { formatMonthWithLeadingZero } from "./FormatLeadingZeroMonth";

export const ProcessData = (billData) => {
  const currentDate = new Date();
  let currentMonth = currentDate.getMonth() + 1;
  let currentYear = currentDate.getFullYear();

  let totalPaymentSums = {};
  let currentMonthDataLength = {};

  // Iterate over the last 12 months
  for (let i = 0; i < 12; i++) {
    const tempMonth = currentMonth;
    const tempYear = currentYear;

    // Get the previous month and year
    const previousMonth = currentMonth === 1 ? 12 : currentMonth - 1;
    // const previousYear = currentMonth === 1 ? currentYear - 1 : currentYear;

    // Filter data for the current month
    const currentMonthData = billData.filter((item) => {
      let [, date] = item.Date.includes("-")
        ? item.Date.split("-")
        : item.Date.split("/");
      const [, month, year] = date.split("/");
      return (
        month === formatMonthWithLeadingZero(tempMonth) &&
        year === String(tempYear)
      );
    });

    // Calculate total payment sum for the current month
    const totalPaymentSumCurrentMonth = currentMonthData.reduce(
      (accumulator, currentValue) => {
        return parseInt(accumulator) + parseInt(currentValue.TotalPayment);
      },
      0
    );

    // Store the total payment sum for the current month
    totalPaymentSums[`${tempYear}-${formatMonthWithLeadingZero(tempMonth)}`] = totalPaymentSumCurrentMonth;

    // Store the count of items filtered for the current month
    currentMonthDataLength[`${tempYear}-${formatMonthWithLeadingZero(tempMonth)}`] = currentMonthData.length;

    // Move to the previous month
    currentMonth = previousMonth;
    // currentYear = previousYear;
  }

  return { totalPaymentSums, currentMonthDataLength };
};
